import { FarsiDate } from '@insta-club/models';

const fDate = (d: FarsiDate) => `${d.dayOfWeek} ${d.day} ${d.month_name} ${d.year}`;

function ChipDate({ date }: { date: FarsiDate }) {
    return (
        <div className='sticky top-0 z-10 mt-3 mb-4 pt-3'>
            <div className='flex items-center justify-center'>
                {/* <div className='h-px flex-1 bg-gray-200' /> */}
                <div className='mx-3 rounded-md px-3 py-1 text-[11px] text-gray-600'>{fDate(date)}</div>
                {/* <div className='h-px flex-1 bg-gray-200' /> */}
            </div>
        </div>
    );
}

export default ChipDate;

